import React, { useEffect, useState, useMemo, useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'dva';
import { useLocation, history, useSelector } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import webStorage from '@/utils/storageManager';
import { OPT_DETAIL } from '@/constants';
import { TextFieldCom, SelectFieldCom } from './components/FormType';
import { fmtThousand } from '@/utils/comUtil';
import GiftExchangeRecordStyles from './giftExchangeRecordStyles';

export default () => {
  //兑换状态
  const ACTIVITY_POINTS_ORDER_STATUS = webStorage
    .get('DICTOBJ')
    ?.ACTIVITY_POINTS_ORDER_STATUS?.filter(
      (item) =>
        item.dictValue !== 4 && item.dictValue !== 5 && item.dictValue !== 6,
    );
  console.log(ACTIVITY_POINTS_ORDER_STATUS, 'ACTIVITY_POINTS_ORDER_STATUS');
  //礼品类别
  const ACTIVITY_POINTS_GIFT_TYPE = webStorage
    .get('DICTOBJ')
    ?.ACTIVITY_POINTS_GIFT_TYPE?.map((item) => ({
      ...item,
      nameZh: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
    }));
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  const { handleSubmit, control, setValue, watch, getValues, errors } =
    useForm();
  const watchAllFields = watch();
  const [isSubmit, setIsSubmit] = useState(false);
  const [openDialog, setOpenDialog] = useState();
  const { queryOrderDetail } = useSelector(
    (state) => state.giftExchangeRecordForm,
  );

  useEffect(() => {
    if (queryOrderDetail && id) {
      for (let v in queryOrderDetail) {
        setValue(v, queryOrderDetail[v]);
      }
    }
  }, [queryOrderDetail, setValue, id]);
  const saveRef = useRef();
  const ACTIVITY_POINTS_ORDER_STATUS_LIST = useMemo(() => {
    const status = queryOrderDetail.status;
    //  已兑换"EXCHANGE"
    // 已购买"PURCHASED"
    // 已发货"DELIVERED"
    ACTIVITY_POINTS_ORDER_STATUS.forEach((item) => {
      // item.disabled = true;
      if (
        (status === 'EXCHANGE' || status === 'PURCHASED') &&
        item.dictCode === 'DELIVERED'
      ) {
        item.disabled = false;
      } else if (status === 'DELIVERED' && item.dictCode === 'DELIVERED') {
        item.disabled = false;
      }
    });
    return ACTIVITY_POINTS_ORDER_STATUS;
  }, [queryOrderDetail, ACTIVITY_POINTS_ORDER_STATUS]);
  //提交成功
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const values = {
      ...data,
      id,
      address: queryOrderDetail.address,
      city: queryOrderDetail.city,
      district: queryOrderDetail.district,
      mobile: queryOrderDetail.mobile,
      name: queryOrderDetail.name,
      province: queryOrderDetail.province,
      remark: queryOrderDetail.remark,
      status: data.status,
    };
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });
    dispatch({
      type: 'giftExchangeRecordForm/updateOrder',
      payload: {
        values,
      },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '更新成功',
            title: '成功',
          });
          setTimeout(() => history.goBack(), 2000);
        } else {
          setIsSubmit(false);
        }
      },
    });
  };
  //提交失败
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    if (!id) {
      return false;
    }
    dispatch({
      type: 'giftExchangeRecordForm/getQueryOrderDetail',
      payload: {
        values: {
          id,
        },
      },
      callback: () => {},
    });
  }, [id, dispatch]);

  return (
    <GiftExchangeRecordStyles>
      <Box
        data-log={JSON.stringify({
          oid: 'page_point_mall_exchange_record_create',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        height="100%"
      >
        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          pt={3}
          pr={4}
          pb={4}
          pl={4}
        >
          <Box className="gift-exchange-record-head">
            <Box className="gift-exchange-record-head-content">
              <Box className="gift-exchange-record-label">会员姓名</Box>
              <Box className="gift-exchange-record-value">
                {queryOrderDetail.memberName}
              </Box>
            </Box>
            <Box className="gift-exchange-record-head-content">
              <Box className="gift-exchange-record-label">会员号</Box>
              <Box className="gift-exchange-record-value">
                {queryOrderDetail.memberCode}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          pt={3}
          pr={4}
          pb={4}
          pl={4}
          mt={0.5}
        >
          <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
            <Box className="gift-exchange-record-info">
              {/* 左 */}
              <Box className="gift-exchange-record-info-content">
                <Box className="gift-exchange-record-info-title">订单信息</Box>
                <Box className="gift-exchange-record-info-item">
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品订单编号
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.orderNo}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      16位渠道号
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.serialNum}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      微信流水号
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.payNo}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">兑换数量</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.exchangeQuantity}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">消耗积分</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.exchangePoints
                        ? fmtThousand(queryOrderDetail.exchangePoints)
                        : '-'}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">消耗金额</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.exchangeCost
                        ? fmtThousand(queryOrderDetail.exchangeCost)
                        : '-'}
                    </Box>
                  </Box>
                  {opt !== OPT_DETAIL &&
                  queryOrderDetail.giftType === 'REAL_PRIZE' ? (
                    <Box flex="1">
                      <SelectFieldCom
                        typeList={ACTIVITY_POINTS_ORDER_STATUS_LIST || []}
                        label="兑换状态"
                        control={control}
                        name="status"
                        watchAllFields={watchAllFields}
                        setValue={setValue}
                        fieldNames={{ label: 'nameZh', value: 'dictCode' }}
                        errors={errors}
                      />
                    </Box>
                  ) : (
                    <Box className="gift-exchange-record-info-item-content">
                      <Box className="gift-exchange-record-label">兑换状态</Box>
                      <Box className="gift-exchange-record-value">
                        {
                          ACTIVITY_POINTS_ORDER_STATUS?.find(
                            (i) => i.nameEn === queryOrderDetail.status,
                          )?.nameZh
                        }
                      </Box>
                    </Box>
                  )}
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">兑换时间</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.exchangeTime}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">发货时间</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.deliverTime || '-'}
                    </Box>
                  </Box>
                  {opt !== OPT_DETAIL &&
                  queryOrderDetail.giftType === 'REAL_PRIZE' ? (
                    <TextFieldCom
                      label="快递公司"
                      showError={true}
                      control={control}
                      name="expressCompany"
                      setValue={setValue}
                      getValues={getValues}
                      errors={errors}
                    />
                  ) : (
                    <Box className="gift-exchange-record-info-item-content">
                      <Box className="gift-exchange-record-label">快递公司</Box>
                      <Box className="gift-exchange-record-value">
                        {queryOrderDetail.expressCompany || '-'}
                      </Box>
                    </Box>
                  )}
                  {opt !== OPT_DETAIL &&
                  queryOrderDetail.giftType === 'REAL_PRIZE' ? (
                    <TextFieldCom
                      label="物流单号"
                      showError={true}
                      control={control}
                      name="expressNo"
                      setValue={setValue}
                      getValues={getValues}
                      errors={errors}
                    />
                  ) : (
                    <Box className="gift-exchange-record-info-item-content">
                      <Box className="gift-exchange-record-label">物流单号</Box>
                      <Box className="gift-exchange-record-value">
                        {queryOrderDetail.expressNo || '-'}
                      </Box>
                    </Box>
                  )}

                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">收货人</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.name || '-'}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      收货人手机号
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.mobile || '-'}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label">收货地址</Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.province}
                      {queryOrderDetail.city}
                      {queryOrderDetail.district}
                      {queryOrderDetail.address}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      会员手机号
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.mobile || '-'}
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* 右 */}
              <Box className="gift-exchange-record-info-content">
                <Box className="gift-exchange-record-info-title">礼品信息</Box>
                <Box className="gift-exchange-record-info-item">
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品code
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.giftCode}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品名称
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.giftTitle}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品类型
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {ACTIVITY_POINTS_GIFT_TYPE?.find(
                        (i) => i.nameEn === queryOrderDetail.giftType,
                      )?.nameZh || '-'}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      券名称
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.couponName}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      优惠券ID
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.couponId}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      优惠券名称
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.couponName}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品货架ID
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.shelfId}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品货架名称
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.shelfName}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      礼品货架分类名称
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.shelfItemName}
                    </Box>
                  </Box>
                  <Box className="gift-exchange-record-info-item-content">
                    <Box className="gift-exchange-record-label gift-exchange-record-label-auto">
                      备注
                    </Box>
                    <Box className="gift-exchange-record-value">
                      {queryOrderDetail.remark}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box display="flex" gap="0 16px" pt={6}>
              {opt !== OPT_DETAIL && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_point_mall_exchange_record_finish',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  ref={saveRef}
                  variant="contained"
                  className="coupons-setting-button"
                  type="submit"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  完成
                </Button>
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={() => {
                  setOpenDialog(true);
                }}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL
              ? '退出后将不保存设置内容，确定要退出吗？'
              : '确定要退出吗？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </GiftExchangeRecordStyles>
  );
};
